var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1208 0H2.87919C1.29195 0 0 1.29195 0 2.87919V13.8748C0 15.462 1.29195 16.754 2.87919 16.754H19.1208C20.7081 16.754 22 15.462 22 13.8748V2.87919C22 1.29195 20.7081 0 19.1208 0ZM2.87919 1.32886H19.1208C19.9757 1.32886 20.6711 2.0243 20.6711 2.87919V3.18779L11.7899 8.44785C11.3027 8.73651 10.6973 8.73651 10.2093 8.44785L1.32886 3.18779V2.87919C1.32886 2.02503 2.0243 1.32886 2.87919 1.32886ZM19.1208 15.4251H2.87919C2.0243 15.4251 1.32886 14.7297 1.32886 13.8748V4.73221L9.53309 9.59141C9.98564 9.8594 10.4928 9.99302 11 9.99302C11.5072 9.99302 12.0151 9.85866 12.4669 9.59141L20.6711 4.73221V13.874C20.6711 14.7289 19.9757 15.4251 19.1208 15.4251Z",
    fill: "#F3223C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/emailicon.628f827ffc5714ac65d9191d3456d525.svg";
export { ForwardRef as ReactComponent };